export interface PaginationMeta {
  page: number;
  limit: number;
  total: number;
  pages: number;
}

export interface ApiResponseMeta {
  timestamp: string;
  path: string;
  pagination?: PaginationMeta;
}

export interface ApiResponse<T> {
  status: 'success' | 'error';
  statusCode: number;
  message: string;
  data: T;
  meta?: ApiResponseMeta;
  errors?: unknown;
}

export function getData<T>(response: { data: ApiResponse<T> | T }): T {
  const body = response.data as any;
  if (body && typeof body === 'object' && body.status === 'success' && 'data' in body) {
    return body.data as T;
  }
  return body as T;
}

export function getPagination(response: { data: any }): PaginationMeta | undefined {
  const body = response.data;
  return body?.meta?.pagination ?? body?.pagination;
}

export function getEnvelope<T>(response: { data: ApiResponse<T> }): ApiResponse<T> {
  return response.data as ApiResponse<T>;
}
